<mat-form-field	
	[color]="color"
	[appearance]="appearance"
	[floatLabel]="floatLabel"
	[ngClass]="{
		hasError: __hasError
	}"
>
	<mat-label
		[innerHtml]="label"
		[ngClass]="{
			'label-error': __hasError
		}"
	></mat-label>
	<input
		matInput
		[formControl]="_control"
		[placeholder]="placeholder"
		[required]="required"
		[maxlength]="maxLength > 0 ? maxLength : undefined"
		(keypress)="_keyRestrictionFunction($event)"
		[type]="type"
		[ngClass]="{
			inputIsWrong: __hasError
		}"
	/>
	<mat-hint [innerHtml]="hint ? hint : ''"></mat-hint>
	<mat-error style ="font-size: 12px; line-height: 16px;"
		*ngIf="!voidError && !__control.hasError('simActivateError')"
		[ngClass]="{ 'no-wrap': noWrap }"
	>{{ getTheError(error) }}</mat-error>
	<mat-error style ="font-size: 12px; line-height: 16px;"
		*ngIf="__control.hasError('simActivateError')"
		[ngClass]="{ 'no-wrap': noWrap }"
		[innerHtml] = "getTheError(error)"
	></mat-error>
	<mat-spinner
		*ngIf="_status === 'PENDING'"
		[diameter]="18"
		[strokeWidth]="3"
	></mat-spinner>
	<img *ngIf="showImage" class="valid-tick" [src]="imageUrl" />
</mat-form-field>
